import { DirectOrderForm } from "./form.ts";

function init() {
  const windowWidth = window.innerWidth;

  document.querySelectorAll(DirectOrderForm.Selector).forEach((element) => {
    if (element instanceof HTMLElement) {
      const form = new DirectOrderForm(element);

      if (
        windowWidth >= form.viewportMin &&
        windowWidth < form.viewportMax &&
        form.hasError
      ) {
        form.scrollIntoView();
      }
    }
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
